// src/IconArrowUpRightArrowDownLeftFill.tsx
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var Icon = ({
  size = 24,
  ...props
}, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-seed-icon": "true",
    "data-seed-icon-version": "0.0.23",
    width: size,
    height: size,
    ref,
    ...props,
    children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsxs("g", { children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 4.19999C13.3373 4.19999 12.8 3.66273 12.8 2.99999C12.8 2.33725 13.3373 1.79999 14 1.79999H21C21.6628 1.79999 22.2 2.33725 22.2 2.99999V9.99999C22.2 10.6627 21.6628 11.2 21 11.2C20.3373 11.2 19.8 10.6627 19.8 9.99999V5.89704L14.8486 10.8485C14.3799 11.3171 13.6201 11.3171 13.1515 10.8485C12.6829 10.3799 12.6829 9.62009 13.1515 9.15146L18.103 4.19999H14Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.00005 12.8C3.66279 12.8 4.20005 13.3372 4.20005 14V18.1029L9.15152 13.1515C9.62015 12.6828 10.3799 12.6828 10.8486 13.1515C11.3172 13.6201 11.3172 14.3799 10.8486 14.8485L5.89711 19.8H10C10.6628 19.8 11.2 20.3372 11.2 21C11.2 21.6627 10.6628 22.2 10 22.2H3.00005C2.33731 22.2 1.80005 21.6627 1.80005 21V14C1.80005 13.3372 2.33731 12.8 3.00005 12.8Z",
          fill: "currentColor"
        }
      )
    ] }) })
  }
);
var IconArrowUpRightArrowDownLeftFill = forwardRef(Icon);
var IconArrowUpRightArrowDownLeftFill_default = IconArrowUpRightArrowDownLeftFill;
export {
  IconArrowUpRightArrowDownLeftFill_default as default
};
